<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
    yLabel: {
      type: String,
      required: false,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
        ...this.data,
      }
    },
    computedOptions() {
      let defaultOptions = {
        defaultFontColor: '#8791af',
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'rgba(166, 176, 207, 0.1)',
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                min: 0,
              },
              gridLines: {
                color: 'rgba(166, 176, 207, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: this.yLabel,
              },
            },
          ],
        },
      }
      return defaultOptions
    },
  },
  mounted() {
    let self = this
    let timer = setInterval(() => {
      if (self.datasets?.length > 0) {
        clearInterval(timer)
        self.renderChart(this.computedData, this.computedOptions)
      }
    },500)
  },
}
</script>
